module.exports = __webpack_public_path__ + "img/ebcVn.cc436486.svg";